import styled from 'styled-components';
import loader from '../app-loader/app-spinner-modal.styled';

export default styled.div`
  ${loader} {
    width: 30px;
    height: 30px;
    /* border: 2px solid rgba(255, 255, 255, 0.09);
    border-top: 2px solid white; */
  }

  span {
    margin-top: 10px;
    display: block;
    width: 100%;
    text-align: center;
  }
`;
